// https://gorails.com/episodes/dynamic-select-fields-with-rails-hotwire
import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static targets = ["dynamicSelect"]
  static values = {
    url: String,
    param: String
  }

  change(event) {
    let params = new URLSearchParams()
    params.append(this.paramValue, event.target.selectedOptions[0].value)
    params.append("target", this.dynamicSelectTarget.id)
    params.append("blank", this.blankLabel(this.dynamicSelectTarget))

    get(`${this.urlValue}?${params}`, {
      responseKind: "turbo-stream"
    })
  }

  // Preserve whatever blank-option cue the server rendered ("All sites",
  // "All facilities") across turbo-stream option replacements — otherwise the
  // dependent select loses its in-control label after the first cascade.
  blankLabel(select) {
    const blank = select.querySelector('option[value=""]')
    return blank ? blank.textContent : ""
  }
}
